"use client";

import { Icon } from "./Icon";
import { cn } from "@/lib/utils";

interface SearchInputProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
  "aria-label"?: string;
}

export function SearchInput({
  value,
  onChange,
  placeholder = "Search…",
  className = "",
  "aria-label": ariaLabel = "Search",
}: SearchInputProps) {
  return (
    <div className={cn("relative w-full", className)}>
      <Icon
        name="search"
        size={16}
        className="pointer-events-none absolute start-3.5 top-1/2 -translate-y-1/2 text-muted"
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        className={cn(
          "w-full rounded-xl border border-secondary/10 bg-card py-3 ps-10 text-sm text-secondary outline-none transition placeholder:text-muted focus:border-primary/40 focus:ring-2 focus:ring-primary/15",
          value ? "pe-9" : "pe-4",
        )}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange?.("")}
          aria-label="Clear search"
          className="absolute end-3 top-1/2 -translate-y-1/2 text-muted transition-colors hover:text-secondary"
        >
          <Icon name="close" size={14} />
        </button>
      )}
    </div>
  );
}
